import styleConfig from '../../muiTheme';

const {
  palette: {
    gray: { grayA0 },
    primary: { primaryBlue2 },
  },
} = styleConfig;

const styles = {
  root: {
    backgroundColor: styleConfig.palette.gray.grayDD,
  },
  listItemPadding: {
    display: 'flex',
    flexDirection: 'row',
    padding: '12px 12px 12px 12px',
    justifyContent: 'center',
  },
  IconsSize: {
    width: 21,
    height: 21,
    color: primaryBlue2,
  },
  countWrap: {
    height: 24,
    width: 24,
    backgroundColor: styleConfig.palette.red.red3,
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    color: 'white',
    fontSize: '0.75rem',
    borderRadius: 12,
  },
  versionStyle: {
    display: 'flex',
    padding: '0px 0px 20px 30px',
    alignItems: 'center',
  },
  versionStyle1: {
    font: 'normal 14px Arial',
    color: grayA0,
  },
  versionStyle2: {
    font: 'normal 14px Arial',
    margin: '0 5px',
    color: grayA0,
  },
  drawerRow: {
    flexDirection: 'row',
    display: 'flex',
  },
  centerAlign: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginLeft: '10px',
  },
};

export default styles;
